// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"232":"c7b6475b","507":"4d302a03"}[chunkId] + ".chunk.css";
};